import { createContext, useContext } from "react";
import type { SaveState } from "@/types/spotflow";

// The WorkflowPickerField (automation-flow picker) is shared by the V1 and V2
// flow editors, which write their save state to different jotai modules. The
// active editor supplies this gate so the picker can wait for that editor's
// save before opening the sub-flow. No provider → the field falls back to the
// V1 (`editor-jotai`) atoms.
export type WorkflowPickerSaveGate = {
  saveState: SaveState;
  queueSave: () => void;
};

export const WorkflowPickerSaveGateContext =
  createContext<WorkflowPickerSaveGate | null>(null);

export const useWorkflowPickerSaveGate = (): WorkflowPickerSaveGate | null =>
  useContext(WorkflowPickerSaveGateContext);
